// API base URL.
// Локальный тест: frontend/.env.local задаёт VITE_API_BASE=same-origin,
// а Vite проксирует /api на отдельный тестовый backend.
// Боевой хост выбирается в рантайме. Иначе сборка с VITE_API_BASE старого
// домена схлопывается в один адрес, и webapp.vsepoplanu.cc бьётся в
// api.rasklad.shop. Тот отвечает 400 на preflight (Disallowed CORS origin).
const apiByHost = {
  'webapp.rasklad.shop': 'https://api.rasklad.shop',
  'webapp.vsepoplanu.cc': 'https://api.vsepoplanu.cc',
};
const configuredApi = import.meta.env.VITE_API_BASE;
const hostApi = apiByHost[window.location.hostname];
export const API_BASE = hostApi
  ?? (configuredApi === 'same-origin' ? window.location.origin : (configuredApi || 'https://api.rasklad.shop'));
